import { Part } from '../ts/types';
import { defaultSwatch } from './materials';

// export function getSwatch(material: Part['swatch']) {
//     const [materialKey, swatchIndex] = material;
//     return materials[materialKey].swatches.find(swatch => swatch.index === swatchIndex) || defaultSwatch;
// }

export function getColor(part: Part): string {
    if (part.swatch) return part.swatch.value;
    if (part.color) return part.color;
    return defaultSwatch.value;
}
